<table class="piezo_table">
    <!-- Header Row 1 -->
    <tr>
        <th rowspan="2">Sensor #</th>
        <th colspan="3">Triaxial Vibration (mm/s)</th>
        <th colspan="3">Triaxial Acceleration (m/sec²)</th>
        <th colspan="3">Triaxial Displacement (mm)</th>
        <th colspan="3">Triaxial Temperature (°C)</th>
        @if (show_snd_acs) {
            <th colspan="1">Acoustics (dBA)</th>
            <th colspan="1">Δ Ultrasound</th>
        }
    </tr>

    <!-- Header Row 2 -->
    <tr>
        <th>
            <div class="">Radial</div>
            <div class="">(X)</div>
        </th>
        <th>
            <div class="">Tangential</div>
            <div class="">(Y)</div>
        </th>
        <th>
            <div class="">Axial</div>
            <div class="">(Z)</div>
        </th>
        <th>
            <div class="">Radial</div>
            <div class="">(X)</div>
        </th>
        <th>
            <div class="">Tangential</div>
            <div class="">(Y)</div>
        </th>
        <th>
            <div class="">Axial</div>
            <div class="">(Z)</div>
        </th>
        <th>
            <div class="">Radial</div>
            <div class="">(X)</div>
        </th>
        <th>
            <div class="">Tangential</div>
            <div class="">(Y)</div>
        </th>
        <th>
            <div class="">Axial</div>
            <div class="">(Z)</div>
        </th>
        <th>Machine Skin</th>
        <th>DE Bearing</th>
        <th>NDE Bearing</th>
        @if (show_snd_acs) {
            <th></th>
            <th></th>
        }
    </tr>

    <!-- DATA ROWS -->
    <tr *ngFor="let s of sensors">
        <td [ngStyle]="{background:s.color}">{{ s.sensorDNames }}</td>

        <!-- ===== VELOCITY: X Y Z ===== -->
        <td
            [ngStyle]="{background: sensorTableData[s.asset_id]?.velocity?.[0]?.bg_color,color:sensorTableData[s.asset_id]?.velocity?.[0]?.color}">
            {{ sensorTableData[s.asset_id]?.velocity?.[0]?.value ?? '-' }}
        </td>
        <td
            [ngStyle]="{background: sensorTableData[s.asset_id]?.velocity?.[1]?.bg_color,color:sensorTableData[s.asset_id]?.velocity?.[1]?.color}">
            {{ sensorTableData[s.asset_id]?.velocity?.[1]?.value ?? '-' }}
        </td>
        <td
            [ngStyle]="{background: sensorTableData[s.asset_id]?.velocity?.[2]?.bg_color,color:sensorTableData[s.asset_id]?.velocity?.[2]?.color}">
            {{ sensorTableData[s.asset_id]?.velocity?.[2]?.value ?? '-' }}
        </td>

        <!-- ===== ACCELERATION: X Y Z ===== -->
        <td
            [ngStyle]="{background: sensorTableData[s.asset_id]?.acceleration?.[0]?.bg_color,color:sensorTableData[s.asset_id]?.acceleration?.[0]?.color}">
            {{ sensorTableData[s.asset_id]?.acceleration?.[0]?.value ?? '-' }}
        </td>
        <td
            [ngStyle]="{background: sensorTableData[s.asset_id]?.acceleration?.[1]?.bg_color,color:sensorTableData[s.asset_id]?.acceleration?.[1]?.color}">
            {{ sensorTableData[s.asset_id]?.acceleration?.[1]?.value ?? '-' }}
        </td>
        <td
            [ngStyle]="{background: sensorTableData[s.asset_id]?.acceleration?.[2]?.bg_color,color:sensorTableData[s.asset_id]?.acceleration?.[2]?.color}">
            {{ sensorTableData[s.asset_id]?.acceleration?.[2]?.value ?? '-' }}
        </td>

        <!-- ===== DISPLACEMENT: X Y Z ===== -->
        <td
            [ngStyle]="{background: sensorTableData[s.asset_id]?.displacement?.[0]?.bg_color,color:sensorTableData[s.asset_id]?.displacement?.[0]?.color}">
            {{ sensorTableData[s.asset_id]?.displacement?.[0]?.value ?? '-' }}
        </td>
        <td
            [ngStyle]="{background: sensorTableData[s.asset_id]?.displacement?.[1]?.bg_color,color:sensorTableData[s.asset_id]?.displacement?.[1]?.color}">
            {{ sensorTableData[s.asset_id]?.displacement?.[1]?.value ?? '-' }}
        </td>
        <td
            [ngStyle]="{background: sensorTableData[s.asset_id]?.displacement?.[2]?.bg_color,color:sensorTableData[s.asset_id]?.displacement?.[2]?.color}">
            {{ sensorTableData[s.asset_id]?.displacement?.[2]?.value ?? '-' }}
        </td>

        <!-- ===== TEMPERATURE: X Y Z ===== -->
        <td
            [ngStyle]="{background: sensorTableData[s.asset_id]?.temperature?.[0]?.bg_color,color:sensorTableData[s.asset_id]?.temperature?.[0]?.color}">
            {{ sensorTableData[s.asset_id]?.temperature?.[0]?.value ?? '-' }}
        </td>
        <td
            [ngStyle]="{background: sensorTableData[s.asset_id]?.temperature?.[1]?.bg_color,color:sensorTableData[s.asset_id]?.temperature?.[1]?.color}">
            {{ sensorTableData[s.asset_id]?.temperature?.[1]?.value ?? '-' }}
        </td>
        <td
            [ngStyle]="{background: sensorTableData[s.asset_id]?.temperature?.[2]?.bg_color,color:sensorTableData[s.asset_id]?.temperature?.[2]?.color}">
            {{ sensorTableData[s.asset_id]?.temperature?.[2]?.value ?? '-' }}
        </td>

        <!-- ===== AUDIBLE: X ===== -->
        @if (show_snd_acs) {
            <td
                [ngStyle]="{background: sensorTableData[s.asset_id]?.audible?.[0]?.bg_color,color:sensorTableData[s.asset_id]?.audible?.[0]?.color}">
                {{ sensorTableData[s.asset_id]?.audible?.[0]?.value ?? '-' }}
        </td>
        }

        <!-- ===== ULTRASOUND: X ===== -->
        @if (show_snd_acs) {
            <td
                [ngStyle]="{background: sensorTableData[s.asset_id]?.ultrasound?.[0]?.bg_color,color:sensorTableData[s.asset_id]?.ultrasound?.[0]?.color}">
                {{ sensorTableData[s.asset_id]?.ultrasound?.[0]?.value ?? '-' }}
            </td>
        }
       

    </tr>
</table>